export class EngagementErrorBase extends Error {
  constructor(message: string) {
    super(`EngagementError: ${message}`)
  }
}

export class MissingUserIdError extends EngagementErrorBase {
  constructor() {
    super('Missing user ID')
  }
}

export class APIConfigError extends EngagementErrorBase {
  constructor() {
    super('Missing API config')
  }
}

export class MissingJWTError extends EngagementErrorBase {
  constructor() {
    super('Missing JWT')
  }
}

export class AuthenticationError extends EngagementErrorBase {
  constructor(public readonly errorCode: number) {
    super(`Authentication error: ${errorCode}`)
  }
}

export class MissingInitOptionsError extends EngagementErrorBase {
  constructor() {
    super('Missing init options')
  }
}

export class JWTUpdateError extends EngagementErrorBase {
  constructor(message: string) {
    super(`JWT update error: ${message}`)
  }
}
